import React, { useState } from 'react';
import { Button as CarnicaButton } from '@carnica/ui-kit';
import { compose } from '@beef/redux';
import { withAutoMetric } from '@beef/auto-metric';
import { useIsDesktopDimension } from '@beef/ui-kit/hooks';

import { enhancedConnect } from 'utils/lowCodeHelpers';
import {
  canUseClipboard,
  canUseShare,
  clipboardData,
  shareData,
} from 'pages/VotingOfLocationTower/utils/clipboard';

import { Tooltip } from './components/Tooltip';

type CarnicaButtonProps = React.ComponentProps<typeof CarnicaButton>;

interface SharedPageButton {
  children?: string;
  className?: string;
  mode: CarnicaButtonProps['mode'];
  size: CarnicaButtonProps['size'];
  successText: string;
  view: CarnicaButtonProps['view'];
  width: CarnicaButtonProps['width'];
}

const _SharedPageButton: React.FC<SharedPageButton> = ({
  children,
  successText,
  className,
  ...props
}) => {
  const isDesktop = useIsDesktopDimension();
  const [isShowTooltip, setShowTooltip] = useState(false);

  // eslint-disable-next-line consistent-return
  const handleSharedPage = () => {
    if (canUseClipboard && isDesktop) {
      return clipboardData({
        text: window.location.href,
        onFinally: (status) => setShowTooltip(status),
      });
    }

    if (canUseShare && !isDesktop) {
      return shareData({
        text: window.document.title,
        url: window.location.href,
        title: window.document.title,
      });
    }
  };
  return (
    <div className={className}>
      <CarnicaButton onClick={handleSharedPage} {...props}>
        {children}
      </CarnicaButton>
      {isShowTooltip && isDesktop && <Tooltip text={successText} />}
    </div>
  );
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SharedPageButton = compose(
  enhancedConnect(),
  withAutoMetric.Element((props: SharedPageButton) => ({
    name: 'Button',
    text: props.children,
  })),
)(_SharedPageButton) as React.FC<SharedPageButton>;
